import React from "react";
import { Row, Col } from "reactstrap";

import _ from "lodash";
import { commonStyles } from "../../../theme/commonStyles";
import { themeService } from "../../../theme/service/activeTheme.service";
import { LIST_VIEW_SELECTION } from "../../Maintenance/ViewSelection";
import ViewChangerComponent from "../../Common/ViewChangerComponent/ViewChangerComponent";
export const MaintenancePageTopBar = ({ listViewDataToShow, handleListViewSelection }) => {
  return (
    <Row style={themeService(commonStyles.pageBorderRowStyle)}>
      {/*Maintenance Smart Summary*/}
      <Col md="10" style={{ paddingLeft: "0px", position: "unset" }}></Col>
      {/*View change options */}
      <Col md={"2"}>
        <ViewChangerComponent
          LIST_VIEW_SELECTION={LIST_VIEW_SELECTION}
          listViewDataToShow={listViewDataToShow}
          handleListViewSelection={handleListViewSelection}
          placement="TOP_OF_PAGE"
        />
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/MaintenanceWorkOrder/MainteanncePageSections/MaintenancePageTopBar.js